/**
 * @generated SignedSource<<11e65811031d32b3ecc1bc777c6519fa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StoreProductList_packageConnection$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"StoreProductPackageItem_package">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "StoreProductList_packageConnection";
};
export type StoreProductList_packageConnection$key = {
  readonly " $data"?: StoreProductList_packageConnection$data;
  readonly " $fragmentSpreads": FragmentRefs<"StoreProductList_packageConnection">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StoreProductList_packageConnection",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PackageEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "StoreProductPackageItem_package"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PackageConnection",
  "abstractKey": null
};

(node as any).hash = "202e3f60b579a4aa3a7defe29fca0e3d";

export default node;
